<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Teleatendimento</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div class="six wide field">
                  <label for="contract-search-description">
                    Pesquisa por paciente ou médico
                  </label>
                  <input
                    type="text"
                    name="contract-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              resource="calls"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import Grid from './widgets/grid';
import SearchMixins from '@/mixins/search_mixins';

export default {
  name: 'contracts',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  data() {
    return {
      searchForm: {
        description: null
      },
      query: {}
    };
  },

  mounted() {
    this._initSearchForm();
    this.search(this.$route.query.page);
  },

  methods: {
    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          patient_name_or_doctor_name_cont: this.searchForm.description,
          s: ['created_at desc']
        },
        page: page
      };

      if (this.searchForm.state != null) {
        query.q.state_eq = this.searchForm.state;
      }

      this.$refs.grid.toggleLoading();
      Api.calls
        .search(query)
        .then(async response => {
          this.$refs.grid.setData(
            response.data.calls,
            response.data.pagination
          );
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>
